import React, { useState, useEffect } from "react";

import Drawer from "@mui/material/Drawer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CloseIcon from "@mui/icons-material/Close";
import loading from "../assests/images/loading.gif";
import { Col, Container, Row } from "react-bootstrap";
import axios from "../api/axios";

export default function ViewResults({ isOpen, onClose, jobId }) {
  const [jobDetails, setJobDetails] = useState({});
  const [error, setError] = useState(null);
  const [imagesError,setImagesError] =useState(null);
  const [flag, setFlag] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [imageLinks, setImageLinks] = useState({
    bloodSample: null,
    tissueSample: null,
    bloodAll: null,
    tissueAll: null,
    bloodNeutrophilsExcluded: null,
    tissueImmuneCellsOnly: null,
  });

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const fetchData = async () => {
    axios
      .post("/api/job-details", {
        jobid: jobId,
      })
      .then((res) => {
        setJobDetails(res.data);
      })
      .catch((err) => {
        setError("Failed to fetch job details.");
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchImages = async () => {
    setError(null);
    axios
      .post("/api/job-result-images", {
        jobid: jobId,
      })
      .then((res) => {
        res.data.forEach((item) => {
          if (item.downloadLink) {
            setImageLinks((prevState) => ({
              ...prevState,
              [item.elementId]: item.downloadLink,
            }));
          }
        });
        setFlag(!flag);
        setImagesError(null);
      })
      .catch((err) => {
        setImagesError("Failed to load images");
      });
  };

  const downloadParamImage=() => {
    if (!flag) {
      fetchImages();
    }
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <div className="result-drawer">
        <div className="job-results">
          <p className="view-result">Run Details</p>
          <div className="close-button">
            <CloseIcon onClick={onClose} />
          </div>
        </div>
        <hr style={{ marginTop: 0 }} />
        {error ? (
          <p style={{ color: "red" }}>{error}</p>
        ) : jobDetails ? (
          <>
            <Container fluid style={{ padding: "0" }}>
              <Row>
                <Col>
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Run Name
                  </p>
                  <p className="custom-size">{jobDetails?.runName || "N/A"}</p>
                </Col>
                <Col>
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Job Number
                  </p>
                  <p className="custom-size">{jobId}</p>
                </Col>
                <Col className="d-none d-md-block"></Col>
              </Row>
            </Container>

            <hr style={{ marginTop: 0 }} />
            <p
              className="job-para"
              style={{ marginTop: "1rem", marginBottom: "1.5rem" }}
            >
              Job Parameters
            </p>
            <Container fluid style={{ padding: "0" }}>
              <Row>
                <Col
                  xs={6}
                  md={4}
                  className="d-flex flex-column justify-content-between"
                >
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Date
                  </p>
                  <p className="custom-size">{jobDetails?.date || "N/A"}</p>
                </Col>
                <Col
                  xs={6}
                  md={4}
                  className="d-flex flex-column justify-content-between"
                >
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Job Type
                  </p>
                  <p className="custom-size">{jobDetails?.runType || "N/A"}</p>
                </Col>
                <Col
                  xs={6}
                  md={4}
                  className="d-flex flex-column justify-content-between"
                >
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Signature Matrix
                  </p>
                  <p className="custom-size">
                    {jobDetails?.signatureMatrix || "N/A"}
                  </p>
                </Col>
                <Col
                  xs={6}
                  md={4}
                  className="d-flex flex-column justify-content-between"
                >
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Bulk Expression File
                  </p>
                  <p className="custom-size">
                    {jobDetails?.mixtureFile || "N/A"}
                  </p>
                </Col>
                <Col
                  xs={6}
                  md={4}
                  className="d-flex flex-column justify-content-between"
                >
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Quantile Normalization
                  </p>
                  <p className="custom-size">
                    {jobDetails?.applyQuantileNormalization || "N/A"}
                  </p>
                </Col>
                <Col
                  xs={6}
                  md={4}
                  className="d-flex flex-column justify-content-between"
                >
                  <p className="review-text sub-text" style={{ margin: 0 }}>
                    Run Status
                  </p>
                  <p className="custom-size">{jobDetails?.status || "N/A"}</p>
                </Col>
              </Row>
            </Container>

            {jobDetails?.showGraphs && (
              <>
                <p
                  className="view-result"
                  style={{
                    marginBottom: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    toggleExpanded();
                    downloadParamImage(jobId);
                  }}
                >
                  Run Results
                  <span style={{ marginLeft: "10px" }}>
                    {isExpanded ? (
                      <ExpandLessIcon sx={{ color: "#0061BB" }} />
                    ) : (
                      <ExpandMoreIcon sx={{ color: "#0061BB" }} />
                    )}
                  </span>
                </p>

                {isExpanded && (
                  imagesError? <p style={{ color: "red" }}>{imagesError}</p> : (
                  <div>
                    <div className="border-0 border-bottom border-top">
                      <button
                        className="job-para accordion-button collapsed no-focus-outline d-flex justify-content-between align-items-center p-0"
                        style={{ margin: "20px 0" }}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSample"
                        aria-expanded="false"
                        aria-controls="collapseSample"
                      >
                        Barplot by Sample
                        <span
                          className="icon-toggle ms-auto ps-3"
                          style={{ fontSize: "20px" }}
                        ></span>
                      </button>
                      <div
                        id="collapseSample"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingSample"
                      >
                        <div className="text-center">
                          <img
                            id={`${jobDetails.signatureMatrix}Sample`}
                            alt="Loading"
                            src={
                              imageLinks[
                                `${jobDetails.signatureMatrix}Sample`
                              ] || { loading }
                            }
                            style={{
                              width: "100%",
                              maxWidth: "500px",
                              height: "auto",
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="border-0 border-bottom border-top">
                      <button
                        className="job-para accordion-button collapsed no-focus-outline d-flex justify-content-between align-items-center p-0"
                        style={{ margin: "20px 0" }}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseAll"
                        aria-expanded="false"
                        aria-controls="collapseAll"
                      >
                        Boxplot by Cell Type (All Cell Types)
                        <span
                          className="icon-toggle ms-auto ps-3"
                          style={{ fontSize: "20px" }}
                        ></span>
                      </button>
                      <div
                        id="collapseAll"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingAll"
                      >
                        <div className="text-center">
                          <img
                            id={`${jobDetails.signatureMatrix}All`}
                            alt="Loading"
                            src={
                              imageLinks[
                                `${jobDetails.signatureMatrix}All`
                              ] || { loading }
                            }
                            style={{
                              width: "100%",
                              maxWidth: "500px",
                              height: "auto",
                            }} // Responsive image
                          />
                        </div>
                      </div>
                    </div>
                    <div className="border-0 border-bottom border-top">
                      <button
                        className="job-para accordion-button collapsed no-focus-outline d-flex justify-content-between align-items-center p-0"
                        style={{ margin: "20px 0" }}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseCellType"
                        aria-expanded="false"
                        aria-controls="collapseCellType"
                      >
                        Boxplot by Cell Type{" "}
                        {jobDetails.signatureMatrix === "blood"
                          ? "(Neutrophils Excluded)"
                          : "(Immune Cells Only)"}
                        <span
                          className="icon-toggle ms-auto ps-3"
                          style={{ fontSize: "20px" }}
                        ></span>
                      </button>
                      <div
                        id="collapseCellType"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingCellType"
                      >
                        <div className="text-center">
                          <img
                            id={
                              jobDetails.signatureMatrix === "blood"
                                ? "bloodNeutrophilsExcluded"
                                : "tissueImmuneCellsOnly"
                            }
                            alt="Boxplot"
                            src={
                              imageLinks[
                                jobDetails.signatureMatrix === "blood"
                                  ? "bloodNeutrophilsExcluded"
                                  : "tissueImmuneCellsOnly"
                              ] || { loading }
                            }
                            style={{
                              width: "100%",
                              maxWidth: "500px",
                              height: "auto",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        ) : (
          <p>Loading job details...</p>
        )}
      </div>
    </Drawer>
  );
}
